<template>
    <div class="pc-page-wrapper">
        <div class="pc-page-board">
            <div class="form-box custom-form-dialog thin-scrollbar">
                <div class="form-box-title">
                    <h5>入职登记表</h5>
                </div>
                <div class="form_field_box" :class="isApply ? 'form_disabled' : ''">
                    <CustomFormPc
                        :field_list="formInfoList"
                        :form_detail="formData"
                        :pk_id="1"
                        ref="custom_form"
                        :is_form_module="true"
                        @submit-form="submitFormData"
                        v-if="dataLoaded"
                    />
                </div>
                <div class="form-btn-box">
                    <el-button @click="handleClickApply" type="primary" class="form-submit-btn" :disabled="isApply">{{
                        isApply ? "已申请，等待审核中" : "申请加入"
                    }}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getCompanyFormFields, userEditByInvite, GetUserInviteInfo, getUserDetail } from "@/api/index.js";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import { decryptAES } from "@/utils/index";
import { mapState } from "vuex";

export default {
    components: {
        CustomFormPc,
    },
    data() {
        return {
            isApply: false, // 是否已经申请

            formInfoList: [],
            formData: null,
            loading: false,
            dataLoaded: false,

            phone: "",
            company_id: "",
            invite_id: "",

            type: "", // 2=企业成员邀请,1=新员工加入
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        if (this.$route.query) {
            this.company_id = this.$route.query.company_id;
            this.phone = this.$route.query.phone;
            this.invite_id = this.$route.query.invite_id ? decryptAES(this.$route.query.invite_id) : "";
            this.type = this.$route.query.type;
        }
        this._getFromFields();
    },
    methods: {
        // 获取审批的字段
        _getFromFields() {
            this.loading = true;
            getCompanyFormFields({
                field_form: "users",
                company_id: this.company_id,
            })
                .then((res) => {
                    if (res.code === 200) {
                        const newFormInfoList = res.data
                            .filter((item) => item.extend.is_form_show) // 过滤第一级
                            .map((item) => {
                                if (item._child) {
                                    // 过滤掉 child.is_form_show_can_close 为 false 的项
                                    item._child.forEach((child) => {
                                        if (child.field_key != "name" && child.field_key != "phone") {
                                            child.is_required = 0; // 将 is_required 字段改为 0
                                        }
                                        if (child.field_type == "table") {
                                            if (child._child && child._child.length) {
                                                child._child.forEach((tableChild) => {
                                                    tableChild.is_required = 0; // 将 is_required 字段改为 0
                                                });
                                            } else {
                                                child._child = [];
                                            }
                                        }
                                    });
                                    const filteredChildren = item._child.filter((child) => child.extend.is_form_show);
                                    return {
                                        ...item,
                                        _child: filteredChildren, // 返回新的对象，包含过滤后的子项
                                    };
                                }
                                return item; // 如果没有 _child，直接返回原项
                            });

                        this.formInfoList = newFormInfoList;
                        this.formData = {
                            phone: {
                                phone_type: "1",
                                prefix: "+86",
                                value: this.phone,
                            },
                        };
                        this.getUserInviteInfo();
                    } else {
                        this.$message.error(res.message);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取用户是否填写过邀请信息
        getUserInviteInfo() {
            GetUserInviteInfo({ user_id: this.userInfo.id }).then((res) => {
                if (res.code === 200) {
                    if (res.data.has_invited) {
                        // 编辑过了
                        this.isApply = true;
                        let formInfoList = this.formInfoList.map((item) => {
                            if (item._child) {
                                item._child.forEach((child) => {
                                    child.field_disabled = true;
                                });
                            }
                            return item;
                        });
                        this.formInfoList = formInfoList;
                        getUserDetail({
                            user_id: this.userInfo.id,
                        }).then((res) => {
                            if (res.code === 200) {
                                var detail = res.data;
                                if (detail.gender && detail.gender.value == 0) {
                                    detail.gender = {
                                        text: "",
                                        value: "",
                                    };
                                }
                                this.formData = detail;
                                this.dataLoaded = true;
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                    } else {
                        this.dataLoaded = true;
                    }
                } else {
                    this.dataLoaded = true;
                }
            });
        },
        handleClickApply() {
            this.$refs.custom_form.handleClickPublish();
        },
        submitFormData(customForm) {
            if (customForm) {
                this.handleDialogConfirm(customForm);
            }
        },
        handleDialogConfirm(customForm) {
            const data = {
                ...customForm,
                user_id: this.userInfo.id,
                invite_id: this.invite_id,
            };
            userEditByInvite(data)
                .then((res) => {
                    if (res.code === 200) {
                        this.$message.success("申请成功");
                        this.isApply = true;
                        if (this.type == 2) {
                            // 通过添加企业成员的链接加入公司申请后直接加入公司即可，无需等待审核
                            this.$router.push({
                                path: "/",
                            });
                        }
                    } else {
                        this.isApply = false;
                    }
                })
                .catch(() => {});
        },
    },
};
</script>
<style lang="scss" scoped>
.pc-page-wrapper {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background-image: url(https://download.hecoos.com/enlightv/2024-04/eSKDGcX5iprHf4Ekm2Eb.jpg);
    background-size: 100% 100%;

    .pc-page-board {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .form-box {
        width: 560px;
        height: 600px;
        box-sizing: border-box;
        border-radius: 8px;
        background: #ffffff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        box-sizing: border-box;
        .form_field_box {
            overflow-y: auto;
            padding: 24px;
            box-sizing: border-box;
            height: 470px;
        }
        .form_disabled .custom_form_wrap {
            position: relative;
        }
        .form_disabled .custom_form_wrap:before {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 10000;
            content: " ";
        }
    }

    .form-box-title {
        padding: 16px 0;
        letter-spacing: 0px;
        line-height: 24px;
        text-align: center;
        border-bottom: 1px solid rgba(217, 217, 217, 1);

        h5 {
            font-size: 16px;
            font-weight: 700;
            color: rgba(34, 34, 34, 1);
        }
    }

    .el-form {
        height: calc(100% - 122px);
        padding: 24px 24px 0;
        overflow-y: scroll;
    }

    .form-btn-box {
        padding: 10px 24px 16px;
        border-radius: 0px 0px, 8px, 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.04);
    }

    .form-submit-btn {
        width: 100%;
    }
    .el-button--primary.is-disabled,
    .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus,
    .el-button--primary.is-disabled:hover {
        border-color: rgba(34, 121, 214, 1);
        background-color: rgba(34, 121, 214, 1);
        color: rgba(255, 255, 255, 1);
    }
    ::v-deep .custom-form-dialog {
        .el-form-item__label {
            font-weight: 400;
        }
    }
}
</style>
